import { ListItem, Tooltip } from "@mui/material";
import React from "react";
import { NavLink } from "react-router-dom";
import Avatar from "../../../components/Avatar/index";
import { createAvatarName, hasImage } from "../../../utils";
import checkpointIcon from "../../../styles/svg/next-checkpoint.svg";
import { TooltipName } from "../../../utils/Enums";
import { useSidebarBoardItem } from "../hooks/useSidebarBoardItem";

function SidebarListItem({ board, style }) {
  const { handleClick, handleAssignedCardsClick } = useSidebarBoardItem(board);

  return (
    <ListItem key={board.board_id} className="menu-ListItem" style={style}>
      <NavLink
        to={`/board/${board.key}`}
        onClick={handleClick}
        className="justify-content-space-between d-flex align-items-center w-100"
      >
        <div className="d-flex align-items-center">
          <Avatar
            key={`board-avtar-${board.board_id}`}
            user_image={board.board_owner_image}
            className="sidebar-board-owner user-avatar"
            title={board.board_owner_name}
            style={
              !hasImage(board.board_owner_image) && {
                bgcolor: board?.board_owner_profile_color?.background,
                color: board?.board_owner_profile_color?.text,
              }
            }
          >
            {`${createAvatarName(board.board_owner_name)}`.toUpperCase()}
          </Avatar>

          {/* <Tooltip title={board.board_name}> */}
          <p className="board-name-text">{board.board_name}</p>
        </div>
        <div className="d-flex align-items-center">
          {board.overdue_checkpoint && (
            <Tooltip title={TooltipName.SIDE_PANEL_ACCORDIAN.CHECKPOINT_MISSED}>
            <img src={checkpointIcon} alt="checkpoint" className="ml-1" />
            </Tooltip>
          )}
          {board.cards_assigned_to_logged_in_user ? (
            <Tooltip title={TooltipName.SIDE_PANEL_ACCORDIAN.CARDS_ASSIGNED}>
            <p
              className="allocated-cards"
              onClick={handleAssignedCardsClick}
            >
              {board.cards_assigned_to_logged_in_user}
            </p>
            </Tooltip>
          ) : ''}
        </div>
      </NavLink>
    </ListItem>
  );
}

export default React.memo(SidebarListItem);
